import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

currentBillingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        font-family: "Mulish";
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        color: ${getColor("text.main")};
    `,
};
